import { LocalDictionaryFactory } from '../../api/api.module'

import { LoggerService } from '../../common/common.module'
import { ConfigurationProfileDetailsDirectiveController } from './configuration-profile-details.directive.controller'

import { IUserSession } from '../../../helpers/user-session'
// import { ConsumerHelper } from '../consumers.helper'

//#region Asset Imports

import './configuration-profile-details.scss'
import * as TEMPLATE from './configuration-profile-details.tpl.html'
import { Enums } from '../../../models/common'
import { CONFIGURATION_PROFILE_SERVICE_NAME, ConfigurationProfileService } from '../../../services/configuration-profile'
import { $Q_SERVICE_NAME, $SCOPE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME } from '../../../services/system'
import { USER_SESSION_SERVICE_NAME } from '../../../services/user-session'

//#endregion

// #region Consts

const TEMPLATE_PATH: string = `./configuration-profile-details.tpl.html`

// #endregion


// #region Setup

export class ConfigurationProfileDetailsDirective implements ng.IDirective {

    restrict = 'E'

    scope = {
        id: '='
    }

    controller = [$SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, '$sce', 'logger', 'localDictionary', USER_SESSION_SERVICE_NAME, CONFIGURATION_PROFILE_SERVICE_NAME, (
        $scope: any,
        $q: ng.IQService,
        $timeout: ng.ITimeoutService,
        $sce: ng.ISCEService,
        logger: LoggerService,
        localDictionary: LocalDictionaryFactory,
        userSession: IUserSession,
        configurationProfileService: ConfigurationProfileService,
    ) => new ConfigurationProfileDetailsDirectiveController(
        $scope,
        $q,
        $timeout,
        $sce,
        logger,
        localDictionary,
        userSession,
        configurationProfileService,
        Enums.ReferenceType.IdConfigurationProfile,
        Enums.SimaxModuleName.Configuration_Profile
    )]

    template = TEMPLATE
}

// #endregion